
import { Badge, Chip, CircularProgress } from "@mui/material";
import React, {memo} from "react";
import { Link } from "react-router-dom";
import DescriptionIcon from '@mui/icons-material/Description';
export const DocsBadge = () => {
  return (
    <Badge color='secondary'
      badgeContent={0}
      max={5000}>
      <Link to="/customer/documents/all-documents">
        <Chip
          sx={{
            ml: 0.5, mr: 0.5, cursor: "pointer",
            '& .MuiChip-icon': {
              color: '#000080',
            },
          }}
          label={
            <div style={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <DescriptionIcon style={{ display: 'flex', color: "#084fff", marginLeft: "5px" }} />
              <span>מסמכים</span>
            </div>
          }
          variant="outlined"
        />
      </Link>
    </Badge>
  )
};


export default memo(DocsBadge);
